import { mapActions } from "vuex"

export default {
    methods: {
        ...mapActions('User', ['codeUser', 'obtainToken', 'getProfile', 'logout']),
    }
}
